module.exports = __webpack_public_path__ + "img/1590656011.6e40ab9b.png";